var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-btn',{attrs:{"icon":_vm.icon,"color":_vm.color,"dark":_vm.dark,"no-fab":_vm.noFab,"large":_vm.large,"disabled":_vm.disabled},on:{"onClick":function($event){return _vm.$emit('onClick')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }